import React, { useEffect } from 'react';
import { Button, Card, FloatingLabel, Form } from 'react-bootstrap';
import IconButton from 'components/common/IconButton';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import { useSelector } from 'react-redux';
import { Spinner } from 'react-bootstrap';
function DatepickerFiltre({ startDate, endDate, onChange }) {
  return (
    <DatePicker
      popperPlacement="bottom-start"
      selected={startDate}
      onChange={onChange}
      startDate={startDate}
      endDate={endDate}
      formatWeekDay={day => day.slice(0, 3)}
      selectsRange
      dateFormat="dd/MM/YYYY"
      className="form-control"
      onKeyDown={e => e.preventDefault()}
    />
  );
}

DatepickerFiltre.propTypes = {
  startDate: PropTypes.any,
  endDate: PropTypes.any,
  onChange: PropTypes.func.isRequired,
};

const FacturationFilteringForm = ({
  onFilterUpdate,
  filterState,
  fetchEntetes,
  entetesLoading,
}) => {
  const user = useSelector(state => state.auth.user);
  const onDateChange = dates => {
    const [start, end] = dates;
    onFilterUpdate({
      ...filterState,
      startDate: start,
      endDate: end,
    });
  };

  const resetFilter = () => {
    const defaultState = {
      selectedMagasin: user.magasin === 'Tous' ? 'Tous' : user.magasin,
      selectedChoix: 'Tous',
      selectedType: user.magasin === 'Tous' ? 'Tous' : user.magasin,
      selectedTypeReglement: user.magasin === 'Tous' ? 'Tous' : user.magasin,
      startDate: new Date().toISOString(),
      endDate: new Date().toISOString(),
      client: '',
      typeTransaction: 'Tous',
    };
    onFilterUpdate(defaultState);
  };

  const handleSelectChange = e => {
    onFilterUpdate({
      ...filterState,
      selectedMagasin: e.target.value,
    });
  };

  const handleSelectChoix = e => {
    onFilterUpdate({
      ...filterState,
      selectedChoix: e.target.value,
    });
  };

  const handleSelectType = e => {
    onFilterUpdate({
      ...filterState,
      selectedType: e.target.value,
    });
  };

  const handleSelectTypeReglement = e => {
    onFilterUpdate({
      ...filterState,
      selectedTypeReglement: e.target.value,
    });
  };

  const handleSelectTypeTransaction = e => {
    onFilterUpdate({
      ...filterState,
      typeTransaction: e.target.value,
    });
  };

  const handleUpdate = () => {
    fetchEntetes();
  };

  return (
    <Card className="shadow-none shadow-show-xl scrollbar">
      <Card.Header className="bg-body-tertiary d-none d-xl-block">
        <h6 className="mb-0 me-3 d-inline-block">Filter</h6>
        <IconButton
          variant="primary"
          iconClassName="me-2"
          icon="minus"
          // transform="shrink-3"
          size="sm"
          onClick={resetFilter}
        >
          Réinitialiser filtre
        </IconButton>
      </Card.Header>
      <Card.Body>
        <Form>
          <div className="mb-2 mt-n2">
            <FloatingLabel controlId="floatingSelect" label="Magasins" className="mb-1 fs-10">
              <Form.Select
                size="sm"
                defaultValue={filterState.selectedMagasin}
                onChange={handleSelectChange}
                value={user.magasin === 'Tous' ? filterState.selectedMagasin : user.magasin}
                disabled={user.magasin !== 'Tous'}
              >
                <option>Tous</option>
                <option>EZZAHRA</option>
                <option>BOUMHEL</option>
                <option>SOUKRA</option>
                <option>SFAX</option>
                <option>MARSA</option>
              </Form.Select>
            </FloatingLabel>
          </div>
          <div className="mb-2 mt-3">
            <FloatingLabel controlId="floatingInput" label="Client" className="mb-3">
              <Form.Control
                type="text"
                value={filterState.client}
                onChange={e => onFilterUpdate({ ...filterState, client: e.target.value })}
              />
            </FloatingLabel>
          </div>

          {/* <div className="mb-2">
            <Form.Label className="mb-1 mt-2 fs-10">Boutiques</Form.Label>
            <MultiSelect
              options={boutiques}
              placeholder="Boutiques"
              onChange={handleBoutiquesChange}
            />
          </div> */}
          <div className="mb-2">
            <Form.Label className="mb-1 mt-2 fs-10">Date</Form.Label>
            <DatepickerFiltre
              startDate={filterState.startDate}
              endDate={filterState.endDate}
              onChange={onDateChange}
            />
          </div>
          <div className="mb-2 mt-n2">
            <FloatingLabel
              controlId="floatingSelect"
              label="Choix facturation"
              className="my-4 fs-10"
            >
              <Form.Select
                size="sm"
                defaultValue={filterState.selectedChoix}
                onChange={handleSelectChoix}
                value={filterState.selectedChoix}
              >
                <option>Tous</option>
                <option>Facturés</option>
                <option>Non facturés</option>
              </Form.Select>
            </FloatingLabel>
          </div>
          <div className="mb-2 mt-n2">
            <FloatingLabel
              controlId="floatingSelect"
              label="Type facturation"
              className="mt-4 fs-10"
            >
              <Form.Select
                size="sm"
                defaultValue={filterState.selectedType}
                onChange={handleSelectType}
                value={filterState.selectedType}
                disabled={user.magasin !== 'Tous'}
              >
                <option>Tous</option>
                <option>BL</option>
                <option>BS</option>
              </Form.Select>
            </FloatingLabel>
          </div>
          <div className="mb-2 mt-n2">
            <FloatingLabel controlId="floatingSelect" label="Type règlement" className="mt-4 fs-10">
              <Form.Select
                size="sm"
                defaultValue={filterState.selectedTypeReglement}
                onChange={handleSelectTypeReglement}
                value={filterState.selectedTypeReglement}
              >
                <option>Tous</option>
                <option>Banque</option>
                <option>Autres</option>
              </Form.Select>
            </FloatingLabel>
          </div>
          <div className="mb-2 mt-n2">
            <FloatingLabel
              controlId="floatingSelect"
              label="Type transaction"
              className="mt-4 fs-10"
            >
              <Form.Select
                size="sm"
                defaultValue={filterState.typeTransaction}
                onChange={handleSelectTypeTransaction}
                value={filterState.typeTransaction}
              >
                <option>Tous</option>
                <option>Ventes</option>
                <option>Retours</option>
              </Form.Select>
            </FloatingLabel>
          </div>
        </Form>
      </Card.Body>
      <Card.Footer className="border-top border-200 py-1">
        <Button varient="primary" className="w-100" onClick={handleUpdate}>
          {entetesLoading ? (
            <div className="d-flex align-items-center justify-content-center gap-2">
              <Spinner animation="border" size="sm" /> <span>Chargement...</span>
            </div>
          ) : (
            'Récupérer'
          )}
        </Button>
      </Card.Footer>
    </Card>
  );
};

FacturationFilteringForm.propTypes = {
  onFilterUpdate: PropTypes.func.isRequired,
  filterState: PropTypes.object,
  fetchEntetes: PropTypes.func.isRequired,
};
export { FacturationFilteringForm };
